// extracted by mini-css-extract-plugin
export default {"divNotFound":"NotFound_divNotFound__uwrYs","upsetSvg":"NotFound_upsetSvg__pKChu"};